import React, { useMemo, useState } from "react";


import CustomField from "components/Form/CustomField";
import HiddenRate from "./HiddenRate";

import { FlexboxGrid, Form, InputNumber, Schema, SelectPicker } from "rsuite";

const { NumberType } = Schema.Types;


export default ({
    defaultFormValue,
    onChangeForm,
    formValue,
    disabled,
    operatorList
}) => {

    const [prefixCount, setPrefixCount] = useState(1);

    const numbersList = useMemo(() => {
        const prefixCount = 0;
        const difference = 6 - prefixCount > 0 ? 6 - prefixCount : 1;

        const numberArray = Array.from(Array(difference).keys());
        return numberArray.map(x => 10 ** x).map(x => ({ label: x, value: +x }));
    }, [formValue]);

    const formModel = Schema.Model({
        sde_key: NumberType()
            .isRequired("Required"),
        prefixes: NumberType()
            .min(1, "Minimum is 1")
            .max(100000, `Maximum is 100000`)
            .isRequired("Required"),
        numbers: NumberType()
            .isRequired("Required")
    });

    return (
        <Form
            defaultFormValue={defaultFormValue}
            onChange={onChangeForm}
            formModel={formModel}
            formValue={formValue}
        >
            <FlexboxGrid justify="start" style={{ margin: "0 0 20px 0" }}>
                <FlexboxGrid.Item>
                    <Form.ControlLabel>Operator</Form.ControlLabel>
                    <CustomField
                        disabled={disabled}
                        accepter={SelectPicker}
                        data={operatorList}

                        labelKey="operatorMccMnc"
                        valueKey="mccMnc"
                        placeholder="Operator"
                        errorPlacement="topRight"
                        name="mccMnc"
                        style={{ width: 520 }}
                    />
                </FlexboxGrid.Item>
            </FlexboxGrid>

            <FlexboxGrid justify="start" style={{ margin: "0 0 20px 0" }}>
                <FlexboxGrid.Item>
                    <Form.ControlLabel>Prefix count</Form.ControlLabel>
                    <Form.Control
                        disabled={disabled}
                        accepter={InputNumber}
                        name="prefixes"
                        placeholder="Prefixes"
                        style={{ width: 180 }}
                        value={prefixCount}
                        onChange={(value) => {
                            setPrefixCount(value);
                        }}
                        min={1}
                        max={100000}
                    />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item className="ml-4">
                    <Form.ControlLabel>Numbers</Form.ControlLabel>
                    <Form.Control
                        disabled={disabled || !formValue?.prefixes}
                        accepter={SelectPicker}
                        data={numbersList}
                        name="numbers"
                        labelKey="label"
                        valueKey="value"
                        placeholder="Numbers"
                        style={{ width: 230 }}
                        searchable={false}
                    />
                </FlexboxGrid.Item>
            </FlexboxGrid>

            <br />
            <HiddenRate />

        </Form>
    );
};